// Constantes geográficas de Argentina usadas en alta de clientes, remitos y NEs.

// Reconoce CABA en cualquiera de sus variantes (CABA, Capital Federal,
// Ciudad Autónoma de Buenos Aires). En el sistema el valor canónico es
// 'CAPITAL FEDERAL'.
export const esCapitalFederal = (prov) =>
  /capital federal|caba|ciudad aut[oó]noma/i.test(prov || '')

export const PROVINCIAS = [
  'Buenos Aires',
  'CAPITAL FEDERAL',
  'Catamarca',
  'Chaco',
  'Chubut',
  'Córdoba',
  'Corrientes',
  'Entre Ríos',
  'Formosa',
  'Jujuy',
  'La Pampa',
  'La Rioja',
  'Mendoza',
  'Misiones',
  'Neuquén',
  'Río Negro',
  'Salta',
  'San Juan',
  'San Luis',
  'Santa Cruz',
  'Santa Fe',
  'Santiago del Estero',
  'Tierra del Fuego',
  'Tucumán',
]

// Principales localidades de la provincia de Buenos Aires (AMBA exhaustivo + interior).
export const LOCALIDADES_BA = [
  // Interior de PBA — casos reales que no estaban (sugerencia #72, 4 sep 2026)
  'Carmen de Patagones',
  // GBA Norte — Vicente López
  'Carapachay', 'Florida', 'Florida Oeste', 'La Lucila', 'Munro', 'Olivos',
  'Vicente López', 'Villa Adelina', 'Villa Martelli',
  // GBA Norte — San Isidro
  'Acassuso', 'Beccar', 'Boulogne', 'Las Lomas de San Isidro', 'Martínez',
  'San Isidro', 'Villa Adelina',
  // GBA Norte — San Fernando
  'San Fernando', 'Victoria', 'Virreyes',
  // GBA Norte — Tigre
  'Benavídez', 'Dique Luján', 'Don Torcuato', 'El Talar', 'General Pacheco',
  'Nordelta', 'Rincón de Milberg', 'Ricardo Rojas', 'Tigre', 'Troncos del Talar',
  // GBA Norte — San Martín
  'Billinghurst', 'José León Suárez', 'San Andrés', 'San Martín', 'Villa Ballester',
  'Villa Lynch', 'Villa Maipú', 'Villa Zagala',
  // GBA Norte — Tres de Febrero
  'Caseros', 'Churruca', 'Ciudad Jardín Lomas del Palomar', 'Ciudadela', 'El Libertador',
  'José Ingenieros', 'Loma Hermosa', 'Martín Coronado', 'Pablo Podestá', 'Remedios de Escalada de San Martín',
  'Sáenz Peña', 'Santos Lugares', 'Villa Bosch', 'Villa Raffo',
  // GBA Norte — Escobar
  'Belén de Escobar', 'Escobar', 'Garín', 'Ingeniero Maschwitz', 'Loma Verde',
  'Maquinista Savio', 'Matheu', 'Maschwitz',
  // GBA Norte — Pilar
  'Del Viso', 'Fátima', 'La Lonja', 'Manzanares', 'Pilar', 'Presidente Derqui',
  'Villa Astolfi', 'Villa Rosa',
  // GBA Norte — Malvinas Argentinas
  'Grand Bourg', 'Ingeniero Pablo Nogués', 'Los Polvorines', 'Pablo Nogués',
  'Tortuguitas', 'Villa de Mayo',
  // GBA Norte — José C. Paz / San Miguel
  'José C. Paz', 'Bella Vista', 'Campo de Mayo', 'Muñiz', 'San Miguel',
  // GBA Oeste — Hurlingham
  'Hurlingham', 'Villa Tesei', 'William C. Morris',
  // GBA Oeste — Ituzaingó
  'Ituzaingó', 'Villa Gobernador Udaondo', 'Villa Udaondo',
  // GBA Oeste — Morón
  'Castelar', 'El Palomar', 'Haedo', 'Morón', 'Villa Sarmiento',
  // GBA Oeste — Merlo
  'Libertad', 'Mariano Acosta', 'Merlo', 'Parque San Martín', 'Pontevedra',
  'San Antonio de Padua', 'Padua',
  // GBA Oeste — Moreno
  'Cuartel V', 'Francisco Álvarez', 'La Reja', 'Moreno', 'Paso del Rey', 'Trujui',
  // GBA Oeste — La Matanza
  'Aldo Bonzi', 'Ciudad Evita', 'Gregorio de Laferrere', 'González Catán', 'Isidro Casanova',
  'La Tablada', 'Lomas del Mirador', 'Rafael Castillo', 'Ramos Mejía', 'San Justo',
  'Tapiales', 'Villa Celina', 'Villa Eduardo Madero', 'Villa Luzuriaga', 'Villa Insuperable',
  'Virrey del Pino', '20 de Junio', 'Veinte de Junio',
  // GBA Sur — Avellaneda
  'Avellaneda', 'Crucecita', 'Dock Sud', 'Gerli', 'Piñeyro', 'Sarandí', 'Villa Domínico', 'Wilde',
  // GBA Sur — Lanús
  'Lanús', 'Lanús Este', 'Lanús Oeste', 'Monte Chingolo', 'Remedios de Escalada', 'Valentín Alsina',
  // GBA Sur — Lomas de Zamora
  'Banfield', 'Ingeniero Budge', 'Lomas de Zamora', 'Llavallol', 'Temperley', 'Turdera', 'Villa Centenario', 'Villa Fiorito',
  // GBA Sur — Almirante Brown
  'Adrogué', 'Burzaco', 'Claypole', 'Don Orione', 'Glew', 'José Mármol', 'Longchamps',
  'Malvinas Argentinas', 'Ministro Rivadavia', 'Rafael Calzada', 'San Francisco Solano', 'San José',
  // GBA Sur — Quilmes
  'Bernal', 'Bernal Oeste', 'Don Bosco', 'Ezpeleta', 'Quilmes', 'Quilmes Oeste', 'San Francisco Solano', 'Solano',
  // GBA Sur — Berazategui
  'Berazategui', 'Hudson', 'Pereyra', 'Plátanos', 'Ranelagh', 'Sourigues', 'Villa España',
  // GBA Sur — Florencio Varela
  'Bosques', 'Florencio Varela', 'Gobernador Costa', 'Ingeniero Allan', 'Villa San Luis', 'Villa Vatteone', 'Zeballos',
  // GBA Sur — Esteban Echeverría
  '9 de Abril', 'Nueve de Abril', 'Canning', 'El Jagüel', 'Luis Guillón', 'Monte Grande',
  // GBA Sur — Ezeiza
  'Aeropuerto Ezeiza', 'Carlos Spegazzini', 'Ezeiza', 'José María Ezeiza', 'La Unión', 'Tristán Suárez',
  // GBA Sur — Presidente Perón
  'Guernica', 'San Vicente',
  // Interior PBA
  'Azul', 'Bahía Blanca', 'Balcarce', 'Baradero', 'Bragado', 'Campana', 'Cañuelas',
  'Chacabuco', 'Chascomús', 'Chivilcoy', 'Dolores', 'General Rodríguez', 'Junín',
  'La Plata', 'Lobos', 'Luján', 'Mar del Plata', 'Marcos Paz', 'Mercedes', 'Necochea',
  'Olavarría', 'Pergamino', 'Pinamar', 'Ramallo', 'Saladillo', 'San Andrés de Giles',
  'San Nicolás', 'San Pedro', 'Tandil', 'Tres Arroyos', 'Villa Gesell', 'Zárate',
].filter((v, i, a) => a.indexOf(v) === i).sort((a, b) => a.localeCompare(b, 'es'))

// Normaliza para comparar: minúsculas, sin tildes/diacríticos, trim.
const _norm = (s) =>
  String(s || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase()

// Devuelve la opción canónica de PROVINCIAS que matchea el valor dado
// (ignorando mayúsculas/tildes). Capital Federal se reconoce por sus alias
// (CABA / Ciudad Autónoma…) → 'CAPITAL FEDERAL'. Si no hay match, devuelve el
// valor original tal cual (no se pierde el dato).
export const matchProvincia = (valor) => {
  const v = String(valor || '').trim()
  if (!v) return ''
  if (esCapitalFederal(v)) return 'CAPITAL FEDERAL'
  const n = _norm(v)
  const directo = PROVINCIAS.find(p => _norm(p) === n)
  if (directo) return directo
  // Google Places nombra a varias provincias con prefijo ("Provincia de Buenos
  // Aires", "Provincia de Córdoba"). Sin sacarlo no matchea ninguna opción y el
  // selector de provincia queda VACÍO — que es lo que se veía al elegir una
  // dirección del GBA/interior.
  const sinPrefijo = _norm(v).replace(/^provincia\s+de\s+/, '')
  return PROVINCIAS.find(p => _norm(p) === sinPrefijo) || v
}

// Devuelve la opción canónica de LOCALIDADES_BA que matchea el valor dado
// (ignorando mayúsculas/tildes). Si no hay match, devuelve el valor original
// (localidades de interior se cargan como texto libre).
export const matchLocalidad = (valor) => {
  const v = String(valor || '').trim()
  if (!v) return ''
  const n = _norm(v)
  return LOCALIDADES_BA.find(l => _norm(l) === n) || v
}
